import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RedefinirSenhaPayload {
  Token: string;
  NovaSenha: string;
}

export interface RedefinirSenhaResponse {
  Codigo?: number;
  Mensagem: string;
  Sucesso: boolean;
  Error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RedefinirSenhaService {
  private apiUrl = 'https://localhost:7103/api/Usuario/RedefinirSenha'; // Ajuste a URL conforme sua API

  constructor(private http: HttpClient) { }

  redefinirSenha(token: string, novaSenha: string): Observable<RedefinirSenhaResponse> {
    const payload: RedefinirSenhaPayload = { 
      Token: token, 
      NovaSenha: novaSenha 
    };
    return this.http.post<RedefinirSenhaResponse>(this.apiUrl, payload);
  }
}

